import { render, staticRenderFns } from "./detail-list.vue?vue&type=template&id=185adba7&scoped=true"
import script from "./detail-list.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-list.vue?vue&type=style&index=0&id=185adba7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185adba7",
  null
  
)

export default component.exports